
// 供应商管理
import Layout from '@/layout'

const supplierRoute = [
  {
    path: '/supplier',
    component: Layout,
    redirect: '/supplier/supplierList',
    name: 'supplier',
    alwaysShow: true, // will always show the root menu
    meta: {
      title: '采购管理',
      icon: 'icon-cart',
      roles: ['ROLE_STAFF']
    },
    children: [
      {
        path: 'supplierList',
        component: () => import('@/views/supplier/supplierList'),
        name: 'supplierList',
        meta: {
          title: '供应商列表',
          icon: 'gongyingshang'
        }
      },
      {
        path: 'annual-audit-supplier',
        component: () => import('@/views/process/annualSupplier/index'),
        name: 'annualAuditSupplier',
        meta: {
          title: '供应商年度评审【申请】',
          icon: 'form'
        }
      },
      {
        path: 'annual-supplier-center',
        component: () => import('@/views/taskCenter/annualSupplier/index'),
        name: 'annualSupplierCenter',
        meta: {
          title: '供应商年度评审【审批】',
          icon: 'check-result'
        }
      },
		  {
		    path: 'supplierVerify',
		    name: 'viewSupplierVerify',
		    component: () => import('@/views/supplier/supplierVerify'),
		    meta: {
		      title: '供应商年度评审【查看】',
		      icon: 'user'
		    }
		  },
      {
        path: 'supplierAdd',
        name: 'supplierAdd',
        component: () => import('@/views/supplier/supplierAdd'),
        meta: {
          title: '新增供应商评审【申请】',
          icon: 'user'
        }
      },
      {
        path: 'supplier-center',
        component: () => import('@/views/taskCenter/supplierCenter/index'),
        name: 'supplierCenter',
        meta: {
          title: '新增供应商评审【审批】',
          icon: 'check-result'
        }
      },
      {
        path: 'supplierEdit/:id',
        name: 'supplierEdit',
        component: () => import('@/views/supplier/supplierEdit'),
        meta: {
          title: '供应商详情',
          icon: 'user'
        },
        hidden: true
      },
      {
        path: 'supplierEditInfo/:id',
        name: 'supplierEditInfo',
        component: () => import('@/views/supplier/supplierEditInfo'),
        meta: {
          title: '修改供应商',
          icon: 'user'
        },
        hidden: true
      },
      {
        path: 'supplierVerify/:id',
        name: 'supplierVerify',
        component: () => import('@/views/supplier/supplierVerify'),
        meta: {
          title: '供应商年审',
          icon: 'user'
        },
        hidden: true
      },
      {
        path: 'view-supplier',
        component: () => import('@/views/supplier/supplierAdd'),
        name: 'viewSupplier',
        meta: {
          title: '审批-新增供应商',
          icon: 'user'
        },
        hidden: true
      },
      {
        path: 'view-annual-supplier',
        component: () => import('@/views/process/annualSupplier/index'),
        name: 'viewAnnualSupplier',
        meta: {
          title: '审批-供应商年度评审',
          icon: 'user'
        },
        hidden: true

      },
      {
        path: 'view-verify-supplier/:id',
        component: () => import('@/views/process/annualSupplier/index'),
        name: 'viewVerifySupplier',
        meta: {
          title: '查看-年审供应商',
          icon: 'user'
        },
        hidden: true

      }
    ]
  }
]

export default supplierRoute



// WEBPACK FOOTER //
// ./src/router/modules/supplier.js